import { IWbUserInfo } from '@interco/inter-webview-bridge'

export const userInfoMock: IWbUserInfo = {
  account: '1234567890',
  birthDate: 19900101,
  email: 'john.doe@example.com',
  name: 'John Doe',
  cpf: '1234567890',
  phoneNumber: '1234567890',
  segmentation: 'DIGITAL',
  userType: 'bank_account',
  operator: '123',
  cellPhoneNumber: '1234567890',
  profile: '123',
  bankAccountList: [
    {
      cpfCnpj: '12345678000199',
      name: 'John Doe LTDA',
      account: '9876543210',
      current: true,
    },
  ],
  hasBranches: true,
  gaStatus: 'ACTIVE',
}
